
import Icon from "@/orders/components/Icon/index.vue";
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { Center, ServicePoint } from "@/orders";
import { Getter } from "vuex-class";

@Component({
  components: {
    Icon,
  },
})
export class Centers extends Vue {
  @Getter("getCashTodayServicePointsOrders") getCashTodayServicePoints!: ServicePoint[];
  @Model("value") filteredCenters!: Center[];
  @Prop({ required: true }) items!: Center[];

  eyes = require("@/orders/assets/icons/icon-eye.svg");
  selectedItems: Center[] = [];
  filterItems: Center[] = [];
  searchTerm = "";
  isSelectAll = true;
  isSelectAllCashToday = false;

  created(): void {
    this.filterItems = this.getFilterItems();
    this.selectedItems = [...this.filteredCenters];
  }

  selectOrUnselectAll(): void {
    if (this.cashTodayCenters.length === this.filterItems.length) {
      this.isSelectAllCashToday = this.isSelectAll;
      this.selectedItems = this.isSelectAll ? [...this.filterItems] : [];
      return;
    }

    if (this.cashTodayCenters.length > 0) {
      this.isSelectAllCashToday = !this.isSelectAll;
    }

    this.selectedItems = this.isSelectAll ? [...this.filterItems] : [];
  }

  selectOrUnselectAllCashToday(): void {
    if (this.cashTodayCenters.length === this.filterItems.length) {
      this.isSelectAll = this.isSelectAllCashToday;
      this.selectedItems = this.isSelectAll ? [...this.filterItems] : [];
      return;
    }

    this.isSelectAll = !this.isSelectAllCashToday;

    this.selectedItems = this.isSelectAllCashToday ? [...this.cashTodayCenters] : [...this.filterItems];
  }

  @Watch("selectedItems")
  onChangeItemsSelected(): void {
    this.isSelectAll = this.selectedItems.length == this.filterItems.length;
    if (this.cashTodayCenters.length > 0) {
      this.isSelectAllCashToday = this.areCentersEqual(this.selectedItems, this.cashTodayCenters, "id");
    }
    this.$emit("value", this.selectedItems);
  }

  areCentersEqual<K extends keyof Center>(firstArray: Center[], secondArray: Center[], attribute: K): boolean {
    if (firstArray.length !== secondArray.length) {
      return false;
    }

    const firstArrayAttributes = firstArray.map((item) => item[attribute]);
    const secondArrayAttributes = secondArray.map((item) => item[attribute]);

    const firstSortedArray = [...firstArrayAttributes].sort();
    const secondSortedArray = [...secondArrayAttributes].sort();

    return firstSortedArray.every((element, index) => element === secondSortedArray[index]);
  }

  get cashTodayCenters(): Center[] {
    return [
      ...new Map(
        this.getCashTodayServicePoints.map((value) => value.center).map((item) => [item["code"], item])
      ).values(),
    ];
  }

  getFilterItems(): Center[] {
    return this.items.filter((item: Center) => {
      const searchTermLowerCase = this.searchTerm.toLowerCase();
      return (
        item.name.toLowerCase().includes(searchTermLowerCase) ||
        item.code.toLowerCase().includes(searchTermLowerCase) ||
        item.name
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .indexOf(this.searchTerm.toLowerCase()) >= 0 ||
        item.code
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .indexOf(this.searchTerm.toLowerCase()) >= 0
      );
    });
  }
}

export default Centers;
